export enum AlertTypes {
  error = 'error',
  success = 'success',
  warning = 'warning'
}
